import { render } from "./registro_usuario.vue?vue&type=template&id=c67bf2d8&scoped=true"
import script from "./registro_usuario.vue?vue&type=script&lang=js"
export * from "./registro_usuario.vue?vue&type=script&lang=js"

import "./registro_usuario.vue?vue&type=style&index=0&id=c67bf2d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c67bf2d8"]])

export default __exports__